module.exports = __webpack_public_path__ + "img/button_prefix_on.110d1a0f.svg";